import { render, staticRenderFns } from "./BonusType.vue?vue&type=template&id=f310e804"
import script from "./BonusType.vue?vue&type=script&lang=js"
export * from "./BonusType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports